import styled, { css } from 'vue-styled-components';
import {
    ConfirmButton as _ConfirmButton,
    border,
} from '@/styles/common.styled';

import {
    AccountIcon as _AccountIcon,
    Badge as _Badge,
    SetDefaultBtn as _SetDefaultBtn,
} from '@components/profileAccounts/ProfileAccounts.styled';

import COLORS from '@design/colors.js';

import {
    FLEX_CENTER,
    RespondMobile,
    RespondLandscape,
    applyHoverAndPress,
    square,
} from '@styles/common.styled';
import { darken } from 'polished';

import {
    FLEX_VERTICAL_CENTER_DIV,
    FLEX_COLUMN_DIV,
    FLEX_DIV,
} from '@styles/common.styled.component';

export const Wrapper = styled('div')`
    position: fixed;
    z-index: 20;
`;

/* vue header: 48px */
export const Background = styled.div`
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;

    ${RespondMobile`
        top: 48px;
        height: calc(100vh - 48px);
        background-color: white;
    `}
`;

export const ContentWrapper = styled('div', { routeName: String })`
    ${RespondMobile`
        right: 45px;
        top: 25px;
    `}
    ${({ routeName }) =>
        routeName === 'Onboarding' &&
        css`
            top: 47px;
            right: 80px;
            ${RespondMobile`
                right: 45px;
                top: 21px;
            `}
        `}
`;

export const ButtonsWrapper = styled(FLEX_VERTICAL_CENTER_DIV)`
    .arrow-icon {
        margin-left: 4px;
        fill: white;
        width: 12px;
        height: 12px;
        cursor: pointer;
    }
`;

export const AccountIcon = _AccountIcon.extend`
    cursor:pointer;
    flex-shrink: 0;
`;

export const AccountIconBig = styled.span`
    ${square(48)}
    ${border(COLORS['blue-35'])};
    ${FLEX_CENTER}
    border-radius: 50%;
    color: ${COLORS['blue-35']};
    font-size: 18px;
    font-weight: 600;
    ${RespondMobile`
        width: 40px;
        height: 40px;
        font-size: 16px;
    `};
`;

export const Bottom = styled.div`
    position: absolute;
    top: 48px;
    left: 0;
    animation-duration: 0.2s;
    width: 336px;
    border-radius: 4px;
    box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.1);
    ${border(COLORS['gray-30'])};
    background-color: #ffffff;
    ${RespondMobile`
        width: 90vw;
        box-shadow: 0 8px 36px 0 rgba(0, 0, 0, 0.1);
        ${border(COLORS['gray-20'])};
        position: fixed;
        margin-left: 5vw;
        margin-right: 5vw;
        max-height: calc(100vh - 100px - constant(safe-area-inset-bottom));
        max-height: calc(100vh - 100px - env(safe-area-inset-bottom));
        overflow-y: scroll;

            /* CSS specific to iOS devices */
            width: calc(
                90vw - constant(safe-area-inset-left) -
                    constant(safe-area-inset-right)
            );
            width: calc(
                90vw - env(safe-area-inset-left) - env(safe-area-inset-right)
            );
    `}
`;

export const BottomHeader = styled(FLEX_COLUMN_DIV)`
    width: 100%;
    padding: 24px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    ${RespondMobile`
        padding: 20px;
    `};
`;

export const UserName = styled.span`
    font-size: 18px;
    font-weight: 500;
    color: ${COLORS['gray-100']};
    ${RespondMobile`
        font-size: 16px;
    `};
`;

export const UserEmail = styled.span`
    font-size: 13px;
    font-weight: normal;
    color: ${COLORS['gray-40']};
    ${RespondMobile`
        font-size: 12px;
    `};
`;

export const Accounts = styled(FLEX_COLUMN_DIV)`
    max-height: 272px;
    overflow-y: auto;
    padding-top: 4px;
    padding-bottom: 4px;
    ${RespondMobile`
        /* height: calc(100vh - 270px); */
        max-height: 219px;
    `};
`;

export const SelectedText = styled.span`
    font-size: 13px;
    font-weight: 600;
    color: #4d5058;
    margin-bottom: 5px;
`;

export const AccountDefault = styled('div', { active: Boolean })`
    height: 24px;
    border-radius: 14px;
    ${FLEX_CENTER}
    font-size: 12px;
    font-weight: 500;
    margin-left: 12px;
    padding: 0 12px;
    flex-shrink: 0;

    ${({ active }) =>
        active
            ? css`
                  color: ${COLORS['blue-60']};
                  ${border(COLORS['blue-60'])};
              `
            : css`
                  color: ${COLORS['gray-80']};
                  ${border(COLORS['gray-80'])};
              `}
    ${RespondMobile`
        height: 24px;
    `};
`;

export const ConfirmButton = _ConfirmButton.extend`
    margin-left: auto;
    margin-right: 10px;
    margin-top: 7px;
`;

export const AddAccount = styled.span`
    font-size: 13px;
    font-weight: 600;
    color: white;
`;

export const AccountElem = styled(FLEX_VERTICAL_CENTER_DIV)`
    width: 100%;
    padding: 0px 24px;
    height: 44px;
    cursor: pointer;
    transition: background-color 0.2s;
    flex-shrink: 0;
    ${applyHoverAndPress('white', 'background-color')};
    svg {
        margin-left: auto;
        flex-shrink: 0;
        fill: ${COLORS['blue-60']};
    }
`;

export const Badge = _Badge;

export const ElemText = styled('div', { active: Boolean })`
    color: ${COLORS['gray-100']};
    font-size: 14px;
    font-weight: 500;
    ${({ active }) =>
        active &&
        css`
            color: ${COLORS['blue-60']};
        `};
    ${RespondMobile`
        font-size: 16px;
    `};
`;

export const SetDefaultBtn = _SetDefaultBtn;

export const SettingBtn = styled.button`
    ${FLEX_CENTER}
    height: 36px;
    border-radius: 3px;
    ${border(COLORS['gray-30'])};
    background-color: #ffffff;
    color: ${COLORS['gray-80']};
    font-size: 14px;
    font-weight: 500;
    margin-top: 24px;
    ${applyHoverAndPress('white', 'background-color')};

    ${RespondMobile`
        height: 36px;
    `}
`;

export const UserContainer = FLEX_VERTICAL_CENTER_DIV;

export const UserInfoContainer = styled(FLEX_COLUMN_DIV)`
    margin-left: 16px;
`;

export const LabelContainer = styled(FLEX_DIV)`
    justify-content: space-between;
    padding-left: 24px;
    padding-right: 24px;
    margin-bottom: 17px;
`;

export const ButtonContainer = FLEX_VERTICAL_CENTER_DIV;

export const LogoutContainer = LabelContainer.extend`
    margin-bottom: 0;
    height: 44px;
    ${RespondMobile`
        top: 48px;
    `}
`;

export const AccountLabel = styled.span`
    color: ${COLORS['gray-40']};
    font-size: 13px;
    font-weight: 500;
`;

export const AddLabel = styled.span`
    font-size: 13px;
    font-weight: 600;
    ${FLEX_CENTER}
    cursor: pointer;
    margin-left: auto;
    ${applyHoverAndPress(COLORS['blue-60'])};
    &:hover {
        svg {
            fill: ${darken(0.1, COLORS['blue-60'])};
        }
    }

    &:active {
        svg {
            fill: ${darken(0.2, COLORS['blue-60'])};
        }
    }
    svg {
        margin-right: 4px;
        fill: ${COLORS['blue-60']};
    }
`;

export const Divider = styled.span`
    display: block;
    width: 100%;
    height: 1px;
    background-color: ${COLORS['gray-20']};
`;
